import { useContext, createContext } from "react";

const DEFAULT_CONTEXT = {
    visible: false,
    setVisible: (visible) => {},
};

export const MetamaskWalletModalContext = createContext(DEFAULT_CONTEXT);

export const useMetamaskWalletModal = () =>
    useContext(MetamaskWalletModalContext);
